module.exports = __webpack_public_path__ + "img/petstairs46.4bec9f83.jpg";